import type {OfferTemplatesSearch} from "./-types";
import type {ListOfferTemplatesSearchInput} from "@project/application/sales/offer-templates";
import type {QueryClient} from "@tanstack/react-query";
import type {AnyContext, Register, ResolveParams, SearchSchemaInput} from "@tanstack/react-router";
import {listOfferTemplatesQueryOptions} from "@project/application/sales/offer-templates";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {OfferTemplatesPage} from "./-page/offer-templates.page";
import {OfferTemplatesPending} from "./-page/offer-templates.pending";
import {offerTemplatesSearchSchema} from "./-types";

const validateTemplateSearch = (
  search: ListOfferTemplatesSearchInput & SearchSchemaInput,
): OfferTemplatesSearch => {
  const parsed = offerTemplatesSearchSchema.parse(search);
  return {...parsed, state: parsed.state ?? "ACTIVE"};
};
const templateLoaderDeps = ({search}: {search: OfferTemplatesSearch}) => search;
async function templateLoader({
  context: {queryClient},
  deps,
  cause,
}: {
  context: {queryClient: QueryClient};
  deps: OfferTemplatesSearch;
  cause: "enter" | "preload" | "stay";
}) {
  if (cause === "enter") return queryClient.ensureQueryData(listOfferTemplatesQueryOptions(deps));
  void queryClient.prefetchQuery(listOfferTemplatesQueryOptions(deps));
  return undefined;
}
// TS7 does not infer these installed Router conditional generics; bind the actual parser/deps/loader types.
export const Route = createFileRoute("/_app/sales/offers/templates/")<
  Register,
  typeof validateTemplateSearch,
  ResolveParams<"/">,
  AnyContext,
  AnyContext,
  OfferTemplatesSearch,
  typeof templateLoader
>({
  component: OfferTemplatesPage,
  errorComponent: AppErrorBoundary,
  validateSearch: validateTemplateSearch,
  loaderDeps: templateLoaderDeps,
  loader: templateLoader,
  pendingComponent: OfferTemplatesPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
});
